import { Avatar } from "@circleco/compass/components/Avatar";
import { Icon } from "@circleco/compass/components/Icon";

import type { MasqueradingEntity } from "@/react/types/Masquerading";

export const entityIcons = {
  CommunityMember: "people",
  Paywall: "credit-card",
  InvitationLink: "chain-link",
  AccessGroup: "lock",
} as const;

export const MasqueradeEntityIcon = ({
  entity,
}: {
  entity: MasqueradingEntity;
}) =>
  entity.type === "CommunityMember" ? (
    <Avatar
      name={entity.name}
      src={entity.avatar_url ?? undefined}
      size="xxs"
      decorative
    />
  ) : (
    <Icon name={entityIcons[entity.type]} size="sm" aria-hidden />
  );
